import { useContext } from 'react';
import { PacklinkContext } from '../providers/packlinkContext.js';

const useCdnUrl = () => {
  const context = useContext(PacklinkContext);
  if (!context) {
    throw new Error('Wrap your Component in a PacklinkProvider Component');
  }
  return context.cdnUrl;
};

export { useCdnUrl };
//# sourceMappingURL=useCdnUrl.js.map
